import { render, staticRenderFns } from "./SimpleSearch.vue?vue&type=template&id=56e59afe&scoped=true&"
import script from "./SimpleSearch.vue?vue&type=script&lang=js&"
export * from "./SimpleSearch.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSearch.vue?vue&type=style&index=0&id=56e59afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e59afe",
  null
  
)

export default component.exports